<template>
    <b-modal id="modal-start-game-random" title="Zufallsstart">
        <div id="p5canvas" style="text-align: center"></div>
        <template #modal-footer>
            <div class="w-100">
            <p class="float-left">Der Startspieler wird ausgew&uuml;rfelt.</p>
            <b-button
                variant="success"
                size="sm"
                class="float-right"
                @click="$bvModal.hide('modal-start-game-random')"
            >
                Spiel beginnt in {{countdownTimer}}
            </b-button>
            </div>
        </template>
    </b-modal>
</template>

<script>
    import P5 from 'p5';
    export default {
        props: ['game', 'startDetermineStartPlayer', 'firstleg', 'gameState', 'players'],
        data() {
            return {
                startingPlayerDetermined: false,
                countdownTimer: 5,
                countdown: undefined
            }
        },
        mounted() {
        },
        watch: {
            startDetermineStartPlayer: function(newValue, oldValue) {
                if (newValue == true)
                    this.determineStartingPlayer();
            }
        },
        methods: {
            determineStartingPlayer() {
                // console.log("VUE determine start player component activated")
                //if (this.startingPlayerDetermined) return;
                if (this.firstleg) this.determineStartingPlayerFirstLeg();
                else this.determineStartingPlayerOtherLegs();
            },
            determineStartingPlayerFirstLeg() {
                this.startingPlayerDetermined = true;
                //if there is only one player, always return first player
                if (!this.players[1]) {
                    this.$emit('activePlayer', this.players[0].id);
                    return;
                }
                var startingMethod = null;
                this.game.starting_options.forEach(option => {
                    if (option.name == 'starting_firstleg') startingMethod = option.value;
                });
                if (startingMethod == "Zufall") {
                    this.startRandomSpinner();
                    return;
                } else if (startingMethod == "Spieler 1") {
                    this.$emit('activePlayer', this.players[0].id);
                    return;
                } else if (startingMethod == "Spieler 2") {
                    this.$emit('activePlayer', this.players[1].id);
                    return;
                } else if (startingMethod == "Ausbullen") {
                    alert("Ausbullen ist noch nicht implementiert. Spieler 1 beginnt");
                    this.$emit('activePlayer', this.players[0].id);
                    return;
                }
            },
            determineStartingPlayerOtherLegs() {
                this.startingPlayerDetermined = true;
                //if there is only one player, always return first player
                if (!this.players[1]) {
                    this.$emit('activePlayer', this.players[0].id);
                    return;
                }
                var startingMethod = null;
                this.game.starting_options.forEach(option => {
                    if (option.name == 'starting_otherlegs') startingMethod = option.value;
                });
                if (startingMethod == "Zufall") {
                    this.startRandomSpinner();
                    return;
                } else if (startingMethod == "Verlierer beginnt") {
                    //console.log(this.gameState.last_winner_id)
                    if (this.gameState.last_winner_id === this.players[0].id) this.$emit('activePlayer', this.players[1].id);
                    else this.$emit('activePlayer', this.players[0].id);
                    return;
                } else if (startingMethod == "Abwechselnd") {
                    //console.log(this.game.user2.player.id)
                    if (this.gameState.last_starter_id === this.players[0].id) this.$emit('activePlayer', this.players[1].id);
                    else this.$emit('activePlayer', this.players[0].id);
                    return;
                } else if (startingMethod == "Spieler 1") {
                    this.$emit('activePlayer', this.players[0].id);
                    return;
                } else if (startingMethod == "Spieler 2") {
                    this.$emit('activePlayer', this.players[1].id);
                    return;
                } else if (startingMethod == "Ausbullen") {
                    alert("Ausbullen ist noch nicht implementiert. Spieler 1 beginnt");
                    this.$emit('activePlayer', this.players[0].id);
                    return;
                }
            },
            startRandomSpinner() {
                this.randomStartShown = true;
                var self = this;
                var running = true;
                var startingNumber = 1;
                this.game.starting_options.forEach(option => {
                    if (option.name == 'starting_number') startingNumber = option.value;
                });
                this.$bvModal.show('modal-start-game-random');
                setTimeout( t => {
                    const sketch = s => {
                        let w = 300;
                        let h = 400;
                        var x = 0;
                        var speed = startingNumber;
                        var deceleration = 0.02;

                        s.setup = () => {
                            s.createCanvas(w, h);
                            s.rectMode(s.CENTER);
                            s.ellipseMode(s.CENTER);
                        };

                        s.draw = () => {
                            s.background(240, 240, 240);
                            s.fill(30,30,30);
                            s.textSize(32);
                            s.textAlign(s.LEFT);
                            s.text('Player 1', 10, 40);
                            s.textAlign(s.RIGHT);
                            s.text('Player 2', 300, 380);
                            s.drawBackground();
                            s.drawShape()
                        };

                        s.drawBackground = () => {
                            s.translate (w/2, h/2);
                            s.fill(255,0,0);
                            s.arc(0, 0, 300, 300, s.PI/2, s.PI * 1.5);
                            s.fill(0,0,255);
                            s.arc(0, 0, 300, 300, s.PI * 1.5, s.PI/2);
                        }

                        s.drawShape = () => {
                            s.fill(255,255,255);
                            // s.translate (w/2, h/2);
                            if (speed > 0) {
                                speed -= deceleration;
                            } else {
                                speed = 0;
                                if (running) {
                                    running = false;
                                    self.setStarterTo(x);
                                }

                            }
                            s.rotate(x+=speed);
                            if (x > s.PI*2) x = 0;
                            //s.rect(0, 0, 100, 100);
                            s.triangle(0, -100, -50, 50, 50, 50);
                        }

                        // create methods:
                        s.yourMethod = (x, y) => {
                            // your method
                        }
                    }
                    let canvas = new P5(sketch, window.document.getElementById('p5canvas'));
                }, 0)
                this.countdown = setInterval(() => {
                    this.countdownTimer -= 1;
                    if (this.countdownTimer <= 0) {
                        clearInterval(this.countdown);
                        this.$bvModal.hide('modal-start-game-random');
                    }
                }, 1000)
            },
            setStarterTo(x) {
                console.log(x);
                this.randomStartShown = true;
                if (x < Math.PI) this.$emit('activePlayer', this.players[1].id);
                else this.$emit('activePlayer', this.players[0].id);
            },
            reset() {
                this.startingPlayerDetermined = false
            }
        }
    }
</script>
